// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hnOl","fullView":"styles_fullView__17v3o"};